import './style/global.less';
import React, { useEffect } from 'react';
import '@arco-design/web-react/dist/css/arco.css';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { ConfigProvider } from '@arco-design/web-react';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import axios from 'axios';
import rootReducer from './store';
import PageLayout from './layout';
import { GlobalContext } from './context';
import Login from './pages/login';
import checkLogin from './utils/checkLogin';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import { profile } from './request/api';
import Oauth from './pages/oauth';
import OauthInquiry from './pages/oauthInquiry';

const store = createStore(rootReducer);

function Index() {
  const [lang, setLang] = useStorage('arco-lang', 'zh-CN');
  const [theme, setTheme] = useStorage('arco-theme', 'light');

  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;
      default:
        return zhCN;
    }
  }

  function fetchUserInfo() {
    console.warn('获取用户信息');
    store.dispatch({
      type: 'update-userInfo',
      payload: { userLoading: true },
    });
    profile({}).then((res) => {
      store.dispatch({
        type: 'update-userInfo',
        payload: { userInfo: res.data.profile, userLoading: false },
      });
    });
  }

  useEffect(() => {
    // 白名单不检查
    if (
      ['login', 'oauth', 'oauthInquiry'].includes(
        window.location.pathname.replace(/\//g, '')
      )
    ) {
      return;
    }

    if (checkLogin()) {
      fetchUserInfo();
    } else if (window.location.pathname.replace(/\//g, '') !== 'login') {
      window.location.pathname = '/login';
    }
  }, []);

  useEffect(() => {
    changeTheme(theme);
  }, [theme]);

  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme,
  };

  return (
    <BrowserRouter>
      <ConfigProvider
        locale={getArcoLocale()}
        componentConfig={{
          Card: {
            bordered: false,
          },
          List: {
            bordered: false,
          },
          Table: {
            border: false,
          },
        }}
      >
        <Provider store={store}>
          <GlobalContext.Provider value={contextValue}>
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/oauth" component={Oauth} />
              <Route path="/oauthInquiry" component={OauthInquiry} />
              <Route path="/" component={PageLayout} />
            </Switch>
          </GlobalContext.Provider>
        </Provider>
      </ConfigProvider>
    </BrowserRouter>
  );
}

ReactDOM.render(<Index />, document.getElementById('root'));
